import React from "react";
import 'chart.js/auto';
import { Chart } from 'react-chartjs-2';

export default function BarChartTotal() {
    const labels = ["ม.ค.", "ก.พ.", "มี.ค." , "เม.ย." , "พ.ค." , "มิ.ย." , "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.","พ.ย.","ธ.ค." ];

const dataNew = {
    labels,
    datasets: [
      {
        type: 'bar' ,
        label: 'Height-Avg',
        backgroundColor: "#D1D1D1",
        data: [98, 95, 98, 96, 97, 99, 96, 95, 95, 94, 97, 96],
        borderColor: 'white',
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
      {
        type: 'bar' ,
        label: 'Weight-Avg',
        backgroundColor: "#7B7B7B",
        data: [89, 88, 87, 85, 83, 90, 96, 88, 87, 85, 88, 80],
        borderColor: 'white',
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
      {
        type: 'bar' ,
        label: 'Height/month',
        backgroundColor: "#FFBFBF",
        data: [95, 99, 94, 96, 90, 89, 95, 97, 98, 99, 98, 89],
        borderColor: 'white',
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
      {
        type: 'bar' ,
        label: 'Weight/month',
        backgroundColor: "#F8E17F",
        data: [94, 98, 95, 99, 90, 97, 95, 96, 98, 99, 98, 89],
        borderColor: 'white',
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
      {
        type: 'bar' ,
        label: 'Milk (Ton)',
        backgroundColor: "#A1EF8E",
        data: [95, 94, 95, 97, 88, 85, 90, 97, 92, 91, 84, 99],
        borderColor: 'white',
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "end",
      },
      title: {
        display: false,
        text: "Chart.js Bar Chart",
        align: "center",
      },
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          display: false
        }
      }
    }
  };

  return <Chart style={{ height: "400px", maxHeight:'400px' }} options={options} data={dataNew} />;
}
